import React from "react"
import { CircularProgressbarWithChildren } from "react-circular-progressbar"
import { Tooltip } from "react-tooltip"

import { IPlayer } from "../../../../../types"
import { isDuoMode } from "../../../../../config"
import { getAvatarSrc } from "../../../../../utils/avatar"
import { DEPTH } from "../../../game/depths"
import { useAppSelector } from "../../../hooks"
import { cc } from "../../utils/jsx"
import GamePlayerDetail from "./game-player-detail"

import "react-circular-progressbar/dist/styles.css"
import "./game-player.css"

export default function GamePlayer(props: {
  player: IPlayer
  click: (id: string) => void
  index: number
  teamHp?: number
  isTeammate?: boolean
  teammateAvatar?: string
}) {
  const spectatedPlayerId = useAppSelector(
    (state) => state.game.currentPlayerId
  )
  const selfPlayerId = useAppSelector((state) => state.network.uid)
  const gameMode = useAppSelector((state) => state.game.gameMode)
  const isDuo = isDuoMode(gameMode)

  function playerClick() {
    props.click(props.player.id)
  }

  const maxHp = isDuo ? 200 : 100
  const displayHp = isDuo && props.teamHp != null ? props.teamHp : props.player.life
  const isDead = isDuo ? (props.teamHp != null && props.teamHp <= 0) : props.player.life <= 0

  return (
    <div className="game-player-wrapper">
      <div
        style={{
          top: `${1 + props.index * 12.5}%`,
          backgroundImage: `url('${getAvatarSrc(props.player.avatar)}')`,
          zIndex: DEPTH.PLAYER_ICON
        }}
        className={cc("game-player", {
          spectated: spectatedPlayerId === props.player.id,
          self: selfPlayerId === props.player.id,
          dead: isDead,
          teammate: !!props.isTeammate
        })}
        onClick={playerClick}
        data-tooltip-id={"detail-" + props.player.id}
      >
        <CircularProgressbarWithChildren value={displayHp} maxValue={maxHp} />
        {isDuo ? (
          <div className="my-container life-text life-text-duo">
            <span>{props.player.life}</span>
            <span className="life-text-separator">|</span>
            {props.teammateAvatar && (
              <img
                className="teammate-icon"
                src={getAvatarSrc(props.teammateAvatar)}
                alt=""
                draggable="false"
              />
            )}
            <span>{props.teamHp ?? props.player.life}</span>
          </div>
        ) : (
          <div className="my-container life-text">{props.player.life}</div>
        )}
      </div>
      <Tooltip
        id={"detail-" + props.player.id}
        className="custom-theme-tooltip"
        place="left"
        data-tooltip-offset={{ left: 30, bottom: props.index === 0 ? 50 : 0 }}
        style={{ zIndex: DEPTH.TOOLTIP }}
      >
        <GamePlayerDetail player={props.player} teamHp={props.teamHp} />
      </Tooltip>
    </div>
  )
}
